import "./IconWarningTriangle.scss";

export const IconWarningTriangle = () => {
  return <span className="icon-warning-triangle"></span>;
};
